import { useState } from "react";
import { useAppSelector } from "../../../services/hooks/useAppHooks";
import { useDeleteProductMutation } from "../../../store/products/productsApi";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./ProductItem.css";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { CartPrice } from "../../ui/text/CartPrice/CartPrice";
import { Product } from "../../../services/types/product.type";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";
import { ProductHeader } from "../../ui/ProductHeader/ProductHeader";

interface ProductItemProps {
  item: Product;
  editAction: (uuid: string) => void;
  updatePage: () => void;
}

const gatewayUrl = process.env.REACT_APP_GATEWAY_URL || "";

export const ProductItem = ({
  item,
  editAction,
  updatePage,
}: ProductItemProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const [showMenu, setShowMenu] = useState(false);
  const [deleteProduct] = useDeleteProductMutation();

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const editItem = () => {
    editAction(item.uuid);
    setShowMenu(false);
  };

  const deleteItem = async () => {
    if (window.confirm("Вы действительно хотите удалить этот товар?")) {
      try {
        await deleteProduct(item.uuid).unwrap();
        updatePage();
      } catch (err) {
        console.error("Ошибка удаления вещи", err);
      }
    }
  };

  return (
    <BorderWrap>
      <ItemMenu status={item.status} showMenu={showMenu} menuClick={menuClick}>
        <TextButton text="Редактировать" action={editItem} />
        {user && (user.role === "admin" || user.role === "superadmin") ? (
          <TextButton text="Удалить" margin="1rem 0 0 0" action={deleteItem} />
        ) : (
          <></>
        )}
      </ItemMenu>
      <ProductHeader
        image={
          item && item.images.length > 0
            ? gatewayUrl + item.images[0].imageUrl
            : undefined
        }
        name={item.name}
        productType={item.productType.name}
        collection={item.collection.name}
      />
      <CartPrice price={item.price} />
    </BorderWrap>
  );
};
